const initialState = {
    anchor: 'left',
    prefeitura: [],
    id: '',
    nome: '',
    inscricao_estadual: '',
    data_cadastro: '',
    usuario_cadastro: '',
    data_exclusao: '',
    usuario_exclusao: ''
};

export function prefeitura(state = initialState, action) {
    switch (action.type) {
        case 'FETECHED_ALL_PREFEITURA':
            return {
                ...state,
                prefeitura: action.prefeitura
            };
        case 'PREFEITURA_DETAIL':
            return {
                ...state,
                id: action.id,
                nome: action.nome,
                inscricao_estadual: action.inscricao_estadual,
                data_cadastro: action.data_cadastro,
                usuario_cadastro: action.usuario_cadastro,
                data_exclusao: action.data_exclusao,
                usuario_exclusao: action.usuario_exclusao
            };
        case "PREFEITURA_UPDATED":
            return state;
        case 'PREFEITURA_CLEAR':
            return {
                prefeitura: [],
                id: '',
                nome: '',
                inscricao_estadual: ''
            };
        case "HANDLE_ON_CHANGE":
            return {
                ...state,
                [action.props]: action.value
            };
        default:
            return state
    }
}
